import { NoPhotography } from '@mui/icons-material'
import { ButtonBase, Card, CircularProgress, Grid, Theme, Typography } from '@mui/material'
import * as controllers from 'controllers'
import { VehicleCheckInPhotoType } from 'dtos'
import { useEffect, useState } from 'react'

interface ClusterRemovedPhotoCardProps {
  complete?: boolean
  disabled?: boolean
  documentGuid?: string
  fileName?: string
  label?: string
  onClick?: () => void
  required?: boolean
  type?: 'pulled-cluster'
  vehicleGuid?: string
  warning?: boolean
}

export default function ClusterRemovedPhotoCard({
  complete,
  disabled,
  label,
  onClick,
  documentGuid,
  fileName,
  required,
  type,
  vehicleGuid,
  warning
}: ClusterRemovedPhotoCardProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [photoFileBase64, setPhotoFileBase64] = useState<string>('')
  const [format, setFormat] = useState<string>('')

  const getColor = (theme: Theme): string => {
    if (disabled) {
      return theme.palette.grey[400] // '#b0a8b9'
    } else if (complete) {
      return theme.palette.success.main // '#009c45'
    } else if (warning) {
      return theme.palette.warning.main // '#ffc75f'
    }

    return theme.palette.error.main // '#ff0000'
  }

  const getLabel = () => {
    if (label) {
      return label
    }

    switch (type) {
      case 'pulled-cluster':
        return 'Pulled Cluster'
    }
  }

  useEffect(() => {
    if (documentGuid && vehicleGuid) {
      setFormat('jpeg')
      setIsLoading(true)
      controllers
        .getNeedsClusterRemovedPhotoBase64(vehicleGuid, documentGuid)
        .then(base64 => {
          setPhotoFileBase64(base64)
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setPhotoFileBase64('')
    }
  }, [documentGuid, vehicleGuid])

  return (
    <Card
      component={ButtonBase}
      onClick={onClick}
      sx={theme => ({
        backgroundColor: getColor(theme),
        color: '#fff',
        p: 1,
        width: '220px'
      })}
    >
      <Grid container spacing={0} alignItems='center' justifyContent='center'>
        <Grid item sx={{ minHeight: 112.5, maxHeight: 112.5 }}>
          {isLoading && <CircularProgress sx={{ color: '#fff', mt: 5 }} />}
          {!isLoading && photoFileBase64 && (
            <img alt={type} src={`data:image/${format};base64,${photoFileBase64}`} width={200} id={fileName} height={112.5} />
          )}
          {!isLoading && !photoFileBase64 && (
            <>
              <NoPhotography fontSize='large' sx={{ height: 112.5 }} />
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Typography align='center'>{getLabel()}</Typography>
        </Grid>
      </Grid>
    </Card>
  )
}
